
import { Component, HostBinding, OnInit, ViewChild } from '@angular/core';
import { NgxGlideComponent } from 'ngx-glide';
import { ApiService } from 'src/app/api.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {
  // Get the component instance.
  // Get the component instance.
  @ViewChild(NgxGlideComponent, { static: false })
  ngxGlide!: NgxGlideComponent;
  newBookList0: any;
  newBookList1: any;
  newBookList2: any;
  url = this.api.url;
  museumList: any;
  fameList: any;
  sirisAjillagaList: any;
  constructor(private api: ApiService) { }
  ngOnInit(): void {
    this.GetNewBookList();
    this.GetMuseumList();
    this. GetMTaxonomy();
  }
  play(): void {
    this.ngxGlide.play();
  }
  GetNewBookList(): void {
    this.api.GetNewBookList().subscribe(
      data => {
        this.newBookList0 = data.slice(0,5);
        this.newBookList1 = data.slice(5,10);
        this.newBookList2 = data.slice(10,15);
      }
    )
  }
  GetMuseumList() {
    this.api.GetMuseumList().subscribe(
      data => this.museumList = data
    )
  }
  GetMTaxonomy() {
    this.api.GetMTaxonomy('renwunianfen').subscribe(
      data => {
        this.api.GetfameList(data[0].taxonomyId, 1, 6).subscribe(
          fData => this.fameList = fData.halloffameList
        );
      }
    );
    this.api.GetMTaxonomy('NcmiiCbcga').subscribe(
      data => {
        this.api.GetSirisAjillagaList(data[2].taxonomyId).subscribe(
          aData => this.sirisAjillagaList = aData
        );
      }
    );
  }
}
